import { render } from "./SupportsComponent.vue?vue&type=template&id=0bc2280e"
import script from "./SupportsComponent.vue?vue&type=script&lang=js"
export * from "./SupportsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__